import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFpsBinding, fetchPsOperationDetails } from "../../../api/requests/fps";
import { getQRScanResult } from "./selectors";
export var loadPsOperationDetails = createAsyncThunk('fps:loadPsOperationDetails', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, thunkAPI) {
    var _getQRScanResult, cid, payData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _getQRScanResult = getQRScanResult(thunkAPI.getState()), cid = _getQRScanResult.cid;
          _context.next = 3;
          return fetchPsOperationDetails(cid);
        case 3:
          payData = _context.sent;
          if (payData.qrCode) {
            _context.next = 6;
            break;
          }
          throw new Error('Cannot fetch QR Code Link');
        case 6:
          return _context.abrupt("return", payData);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());
export var fetchBindingThunk = createAsyncThunk('fps:fetchBinding', fetchFpsBinding);